/**
 * One shared "now" for the accessory catalog.
 *
 * Action prices have a validity window, and the list, the filter counts, the
 * price rows and the add-dialog all decide independently whether an action is
 * still running. Each reading the clock on its own means that at an expiry
 * boundary they disagree — the row still shows an action price the dialog no
 * longer offers. This mixin gives the component that owns the catalog a single
 * reactive `now`, which it passes down as a `:now` prop so every consumer
 * answers the question against the same instant.
 *
 * Usage:
 *
 *   import catalogClock from '@/mixins/catalogClock'
 *   export default { mixins: [catalogClock] }   // then :now="now"
 *
 * A minute of drift is invisible for a validity window measured in days, so the
 * refresh is coarse on purpose: no timer per component, no re-render storm.
 */

const REFRESH_INTERVAL_MS = 60 * 1000

export default {
  data() {
    return {
      now: new Date(),
      catalogClockTimer: null,
    }
  },
  mounted() {
    this.catalogClockTimer = setInterval(() => {
      this.now = new Date()
    }, REFRESH_INTERVAL_MS)
  },
  beforeUnmount() {
    clearInterval(this.catalogClockTimer)
    this.catalogClockTimer = null
  },
}
